/* eslint-disable */
"use strict";

import Scrolltop from "./../../components/scrolltop.js";
import { ODUtil } from "./../../components/util.js";

var AppLayoutScrolltop = function() {
    // Private properties
    var _element;
    var _object;

    // Private functions
    var _init = function() {
        _object = new Scrolltop(_element, {
          offset: 300,
          speed: 600,
        });
    }

    // Public methods
	return {
		init: function(id) {
            _element = ODUtil.getById(id);

            if (!_element) {
                return;
            }

            // Initialize
            _init();
		},

        getElement: function() {
            return _element;
        }
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = AppLayoutScrolltop;
}

export default AppLayoutScrolltop;
